import React from 'react';
import ContactForm from './ContactForm';
import GoogleMap from '../../components/GoogleMap';
import ContactUs from '../../assets/contact-us.webp';

const ContactPage = () => {
  return (
    <section className='py-16'>
      <div className="relative">
        <img src={ContactUs} alt="Contact Us" className="w-full h-64 md:h-80 lg:h-96 object-cover" />
        <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <h2 className="text-white text-4xl lg:text-6xl text-center font-normal">Contact Us</h2>
        </div>
      </div>

      <div className="flex justify-center p-4 mt-12">
        <div className="w-full max-w-xl rounded-lg bg-white shadow-lg">
          <div className="w-full p-8">
            <h2 className="mb-6 text-3xl font-semibold text-blue-800 text-center">Get In Touch</h2>
            <p className="mb-8 text-lg text-gray-600 text-center">We’d love to hear from you! Please fill out the form below and we’ll get back to you as soon as possible.</p>
            <ContactForm />
          </div>
        </div>
      </div>
      <div className="mt-12 -mb-20">
        <GoogleMap />
      </div>
    </section>
  );
};

export default ContactPage;
